<script setup>
import useStore from "../store";
import {computed, ref, watch} from "vue";
import {trackEvent} from "../../helpers/track";

const props = defineProps({
  errors: Array,
  submitted: {
    default: false,
    type: Boolean,
  },
})

const store = useStore();
const confirms = ref([])
const autoSet = ref(false)
const model = defineModel({ default: false })

const quoteItems = computed(() => store.quote?.items || [])

const confirmations = computed(() => {


  const count = (participants, lower, upper) => (Number(participants?.[lower]) || 0) + (Number(participants?.[upper]) || 0)

  let compressedParticipants = store.items.reduce((curr, item) => {

    if (item?.participants){
      const existing = curr[item.attraction] ?? { adults: 0, children: 0, seniors: 0, infants: 0 }

      curr[item.attraction] = {
        adults: existing.adults + count(item.participants, 'adults', 'Adult'),
        children: existing.children + count(item.participants, 'children', 'Child'),
        seniors: existing.seniors + count(item.participants, 'seniors', 'Senior'),
        infants: existing.infants + count(item.participants, 'infants', 'Infant'),
      }
    }

    return curr
  }, {});

  let simpleParticipants = {}
  Object.keys(compressedParticipants).forEach(function(key) {
    simpleParticipants[key] = [
        (compressedParticipants[key].adults > 0 ? "adults" : false),
        (compressedParticipants[key].children > 0 ? "children" : false),
        (compressedParticipants[key].seniors > 0 ? "seniors" : false),
        (compressedParticipants[key].infants > 0 ? "infants" : false),
    ].filter(itm => !!itm);
  });

  return store.uniqueAttractions
      .filter((att) => att.confirmations && att.confirmations.length > 0)
      .reduce((curr, att) => {
    let confirmations = att.confirmations;
    if (simpleParticipants?.[att.id]){
      confirmations = confirmations.filter(confirmation => {
        return confirmation.ticket_types.filter((value) => simpleParticipants[att.id].includes(value)).length > 0
      })
    }

    return [...curr, ...confirmations]
  }, [])
})

const hasChildren = computed(() => {
  return store.items.reduce((curr, item) => {

    if (item?.participants && item.participants?.children){
      curr+= item.participants?.children;
    }

    if (item?.participants && item.participants["Child"]){
      curr+= item.participants["Child"];
    }

    return curr
  }, 0);
})

const updateSubscribe = (event) => {
  if (!event.target.checked){
    trackEvent('newsletter-un-tick');
  } else {
    trackEvent('newsletter-re-tick');
  }
}

watch(() => hasChildren, (newValue) => {
  model.value = (confirms.value.length >= confirmations.value?.length + (hasChildren.value  > 0 ? 1 : 0))
}, { deep: true });

watch(() => confirms, (newValue) => {
  model.value = (confirms.value.length >= confirmations.value?.length + (hasChildren.value  > 0 ? 1 : 0))

  store.confirms = confirms;
}, { deep: true });


watch(() => confirmations, (newValue) => {
  model.value = (confirms.value.length >= confirmations.value?.length + (hasChildren.value  > 0 ? 1 : 0));
}, { deep: true });



</script>

<template>
    <div>
        <div class="relative" v-for="(confirmation, ind) in confirmations">
          <div class="customer-field py-3">
            <label class="flex items-center">
              <input
                  v-model="confirms"
                  type="checkbox"
                  name="confirm"
                  data-testid="booking-confirmation"
                  :value="`confirm_${confirmation.message}`"
                  :id="`confirmation_${ind}`"
                  class="border-alert-error border mr-3 h-6 w-6"
              />
              <span class="flex-grow">{{ confirmation.message }}</span>
            </label>
          </div>
        </div>
        <div class="relative" v-if="hasChildren">
          <div class="customer-field py-3">
            <label class="flex items-center">
              <input
                  v-model="confirms"
                  type="checkbox"
                  name="confirm"
                  data-testid="booking-confirmation"
                  :id="`confirmation_children`"
                  value="confirm_children"
                  class="border-alert-error border mr-3 h-6 w-6"
              />
              <span class="flex-grow">I understand that children under 16 must be accompanied by an adult.</span>
            </label>
          </div>
        </div>

        <div v-if="props.submitted && !model"
             class="text-[#F54E4E] text-sm mt-1">
          Please confirm all the requirements for your booking
        </div>

        <div class="relative" v-if="quoteItems.length > 0">
          <div class="customer-field py-3">
            <label class="flex items-center">
              <input
                  v-model="store.subscribe"
                  @change="updateSubscribe"
                  type="checkbox"
                  name="confirm"
                  :id="`confirmation_subscribe`"
                  :true-value="true"
                  :false-value="false"
                  class="border mr-3 h-6 w-6"
              />
              <span class="flex-grow">Subscribe to Capes Foundation for the latest news, events and offers</span>
            </label>
          </div>
        </div>



    </div>
</template>
